

import React from 'react';

const Success = () => {
  return (
    <div className="submitted-page">
      <h1>Form Submitted Successfully!</h1>
      <p>Thank you for registering.</p>
    </div>
  );
};

export default Success;
